import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {FlowEntity} from './flow.entity';
import {SystemEntity} from './system.entity';

@EntityTable('flow_system_xref', '305f9a15-ca59-47bf-85cf-2020a2031d48')
export class FlowSystemXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, FlowEntity, false, false, FieldRelationKind.BELONGS_TO, 'flow', 'aliasId', 'flowId')
    public flowId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Transient()
    public flow: FlowEntity;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

}
